import { useMutation, useQuery } from '@tanstack/react-query'

import { apiFetch } from './apiFetch'

const createInterestSignup = async ({ token, ...data }) => {
  const response = await fetch('/api/v1/interest-signups', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`,
    },
    body: JSON.stringify(data),
  })

  if (response.status >= 500) {
    throw new Error(`HTTP status ${response.status}`)
  }

  const result = await response.json()

  // API returns validation errors in message field
  if (result?.message && typeof result.message === 'object') {
    const error = new Error('Validation failed')
    error.validationErrors = result.message
    throw error
  }

  return result
}

export const useCreateInterestSignup = () =>
  useMutation({
    mutationFn: createInterestSignup,
  })

// Widget queries disable all automatic refetching to prevent request loops.
// Widgets are embedded in iframes where window focus events from the parent page
// would otherwise trigger constant refetches. The data is static for the session.
const widgetQueryOptions = {
  retry: false,
  staleTime: Infinity,
  refetchOnMount: false,
  refetchOnWindowFocus: false,
  refetchOnReconnect: false,
}

export const useProject = (projectId, token) =>
  useQuery({
    queryKey: ['project', projectId, token],
    queryFn: () => apiFetch(`/api/v1/projects/${projectId}`, { token }),
    enabled: !!projectId && !!token,
    ...widgetQueryOptions,
  })

export const useWidgetConfig = (projectId, token) =>
  useQuery({
    queryKey: ['widgetConfig', projectId, token],
    queryFn: () =>
      apiFetch(`/api/v1/projects/${projectId}/widget-config`, { token }),
    enabled: !!projectId && !!token,
    ...widgetQueryOptions,
  })
